module.exports = __webpack_public_path__ + "static/media/img_28.eee56404.JPG";